
import produce from 'immer';

import {
    IInitialState,
} from './interface';

import {
    GET_WEBCHAT,
    GET_WEBCHAT_FAILED,
    GET_WEBCHAT_SUCCESS,
} from './constants';

/**
 * initialState
 */
export const initialState: IInitialState = {
    loading: false,
    error: false,
    errorCode: false,
    response: false,
};

/**
 * appReducer
 * @param state
 * @param action
 */
const initWebchatReducer = (state: any = initialState, action: any) =>
    produce(state, (draft: IInitialState) => {

        switch (action.type) {
            case GET_WEBCHAT:
                draft.loading = true;
                draft.error = false;
                draft.errorCode = false;
                break;
            case GET_WEBCHAT_SUCCESS:
                draft.loading = false;
                draft.response = action.response;
                break;
            case GET_WEBCHAT_FAILED:
                draft.loading = false;
                draft.error = action.error;
                draft.errorCode = action.errorCode;
                break;

        }
    });

export default initWebchatReducer;
